import { render, staticRenderFns } from "./OfficesWorkTimesList.vue?vue&type=template&id=54918111&"
import script from "./OfficesWorkTimesList.vue?vue&type=script&lang=js&"
export * from "./OfficesWorkTimesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports